import styled, { css } from 'styled-components';

export const ListContainer = styled.div`
  ${({ theme, $watchMore }) => css`
    gap: 16px 24px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    margin: 24px 0;
    padding-bottom: ${!$watchMore && '48px'};

    @media(max-width: ${theme.v2.breakpoints.lg}) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media(max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: repeat(2, 1fr);
      margin: 24px;
    }

    @media(max-width: ${theme.v2.breakpoints.sm}) {
      grid-template-columns: repeat(1, 1fr);
      margin: 16px;
    }
  `};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 48px;
`;

export const VisitsEmptyWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 24px 0 0;
    width: auto;
    padding: 98px 0;
  `}
`;

export const VisitsEmpty = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  margin: 0 24px;
  text-align: center;
`;

export const TitleDescriptionWrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 24px 24px 0;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 16px 16px 0;
    }
  `};
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color:${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 24px 24px 0;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 16px 16px 0;
    }
  `};
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
  `};
`;

export const TitleEmpty = styled.h2`
  ${({ theme }) => css`
    align-items: center;
    color:${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    flex-direction: row;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;

    @media(min-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const DescriptionEmpty = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    white-space: break-spaces;
    margin: 0;
    text-align: center;

    @media(min-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;
